import TranslationModel from '../../../../../Spirit/Admin/Interfaces/Models/TranslationModel';

export default class UpdateSleepStoryCategoryRequest  {
	Id?: number = null;
	Translations: Array<TranslationModel> = null;
	constructor(obj?: Partial<UpdateSleepStoryCategoryRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
